import { defineComponent as o, openBlock as t, createBlock as r, unref as p, mergeProps as v, withCtx as d, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const h = /* @__PURE__ */ o({
  name: "IconSim",
  __name: "IconSim",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const n = l;
    return (m, a) => (t(), r(p(i), v(n, { "view-box": "0 0 24 24" }), {
      default: d(() => [...a[0] || (a[0] = [
        e("path", { d: "M8 5.25A.75.75 0 0 1 8.75 6v2a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 8 5.25M11.75 6a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0V6M14 5.25A.75.75 0 0 1 14.75 6v2a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 14 5.25" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M8.5 12.25a1.25 1.25 0 0 0-1.25 1.25v4a1.25 1.25 0 0 0 1.25 1.25h7a1.25 1.25 0 0 0 1.25-1.25v-4a1.25 1.25 0 0 0-1.25-1.25h-7m.25 5v-3.5h6.5v3.5h-6.5",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M4.25 4.5A2.25 2.25 0 0 1 6.5 2.25h8.293a1.25 1.25 0 0 1 .884.366l3.707 3.707a1.25 1.25 0 0 1 .366.884V19.5a2.25 2.25 0 0 1-2.25 2.25h-11a2.25 2.25 0 0 1-2.25-2.25v-15M6.5 3.75A.75.75 0 0 0 5.75 4.5v15a.75.75 0 0 0 .75.75h11a.75.75 0 0 0 .75-.75V7.31l-3.56-3.56H6.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  h as default
};
